import { widgetRegistry } from '../../infrastructure/registry/WidgetRegistry';

import { EmployeeOverviewWidget, employeeOverviewConfig } from './EmployeeOverviewWidget';
import { RunningJobsWidget, runningJobsConfig } from './RunningJobsWidget';
import { PendingTasksWidget, pendingTasksConfig } from './PendingTasksWidget';
import { ActiveProjectsWidget, activeProjectsConfig } from './ActiveProjectsWidget';
import { AnnouncementsWidget, announcementsConfig } from './AnnouncementsWidget';
import { RecentActivitiesWidget, recentActivitiesConfig } from './RecentActivitiesWidget';
import { TimeSummaryWidget, timeSummaryConfig } from './TimeSummaryWidget';

export function registerEmployeeWidgets() {
  widgetRegistry.register(employeeOverviewConfig, EmployeeOverviewWidget);
  widgetRegistry.register(runningJobsConfig, RunningJobsWidget);
  widgetRegistry.register(pendingTasksConfig, PendingTasksWidget);
  widgetRegistry.register(activeProjectsConfig, ActiveProjectsWidget);
  widgetRegistry.register(announcementsConfig, AnnouncementsWidget);
  widgetRegistry.register(recentActivitiesConfig, RecentActivitiesWidget);
  widgetRegistry.register(timeSummaryConfig, TimeSummaryWidget);
}
